export default {
  SET_ROLES(state, roles) {
    state.roles = roles
  },
  REMOVE_ROLE(state, itemId) {
      const roleIndex = state.roles.datas.findIndex((u) => u.id == itemId)
      state.roles.datas.splice(roleIndex, 1)
  },
  SELECTED_ROLE(state,data){
    state.roles.datas = []
    state.roles.total = 1;
    state.roles.per_page = 1;
    state.roles.datas.push(data)
  },
  SET_AUTOCOMPLETE_DATA(state,data){
    state.autocomplete_data = data
  },
  EDIT_ITEM(state,data){
    state.elomark_user = data
  },
  ADD_ITEM(state,data){
    state.elomark_user = data
  },
}
